import React, { ReactElement, useState, useEffect, useContext, FormEvent, useRef } from 'react';
// import { getCleanedStr } from 'project/general/js/helpers';
import { TextBoxDefinition } from 'models/text-box-definition';
// import { deviceObserver } from 'project/general/js/device';
// import { scrollService } from 'project/general/js/scroll-service';
// import { operators } from '@deleteagency/device-observer';
import { FilterContext } from 'components/filters/js/filter-service';

const DEFAULT_PLACEHOLDER = 'Search by keyword';
const KEY = 'keyword';
const KeywordSearch = ({
    placeholderText = DEFAULT_PLACEHOLDER,
    name = KEY,
}: TextBoxDefinition): ReactElement => {
    const ref = useRef<HTMLFormElement>(null);
    const { appliedFilters, setFilter } = useContext(FilterContext);
    const [state, setState] = useState({
        currentValue: appliedFilters[name] || '',
    });

    // const [value, setValue] = useState('');
    const { currentValue } = state;
    useEffect(() => {
        const _value = appliedFilters[name] || '';
        if (_value !== currentValue) setState({ currentValue: _value });
    }, [appliedFilters]);

    /* useEffect(() => {
        console.log(value);
        const _value = appliedFilters[name] || '';
        if (_value !== value) setState({ currentValue: _value });
    }, [value]); */

    const _onChange = ({ currentTarget: { value } }: FormEvent<HTMLInputElement>): void => {
        if (currentValue !== '' && value === '') setFilter({ [name]: '' });
        setState({ currentValue: value });
    };
    /* const _onClick = (): void => {
        const wrapper = document.querySelector('.filter-panel__input.is-mobile');
        const filterMobileBtn = document.querySelector('.filter-mobile-btn');
        if (wrapper != null && filterMobileBtn != null) {
            wrapper.classList.toggle('is-wide');
            filterMobileBtn.classList.toggle('is-hidden');
        }
    }; */
    const _onSubmit = (e: FormEvent): void => {
        e.preventDefault();
        if (typeof currentValue === 'string') {
            /* if (deviceObserver.is('<' as operators, 'tablet') && ref.current) {
                scrollService.scrollToElementsTop(ref.current, 20);
            } */
            setFilter({ [name]: currentValue });
            return;
        }

        setFilter({ [name]: currentValue });
    };
    return (
        <div className="search-page__header">
            <form className="search__form" onSubmit={_onSubmit} ref={ref}>
                <div className="search__icon">
                    <svg className="icon" width="24" height="24" focusable="false">
                        <use xlinkHref="#icon-search"></use>
                    </svg>
                </div>
                <input
                    type="search"
                    className="search__input"
                    placeholder={placeholderText}
                    value={typeof currentValue === 'string' ? currentValue : ''}
                    onChange={_onChange}
                />
                <button
                    className="search__trigger btn btn--header"
                    type="submit"
                    aria-label="start search"
                    disabled={currentValue === ''}
                >
                    Search
                </button>
            </form>
        </div>
    );
};

export { KeywordSearch };
